import Api from "../../../util/Api";

export default function getInitState() {
    return {
        humanResourceFormIsOpen: false,
        humanResourceGridIsOpen: true,
        humanResourceActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új személyzet',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newHumanResourceRow'
            }
        ],
        humanResourceFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToHumanResourceGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetHumanResourceForm'
            }
        ],
        humanResourceRowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyHumanResourceRow'
            }, {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyHumanResourceRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteHumanResourceRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteHumanResourceRow'
            }
        ],
        humanResourceHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "fullName",
                label: "Név",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: false
            },
            {
                name: "identityCardNumber",
                label: "Személyi igazolvány száma",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "title",
                label: "Titulus",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "lastName",
                label: "Vezetéknév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "firstName",
                label: "Keresztnév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "nationality",
                label: "Állampolgárság",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "sex",
                label: "Nem",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getSexOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "placeOfBirth",
                label: "Születési hely",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: "text",
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "dateOfBirth",
                label: "Születési dátum",
                formType: 'date',
                slot_name: "date_format",
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "birthLastName",
                label: "Születési vezetéknév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "birthFirstName",
                label: "Születési keresztnév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "motherName",
                label: "Anyja neve",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "isRetired",
                label: "Nyugdíjas",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [{id: '0', text: 'Nem'}, {id: '1', text: 'Igen'}],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "deleted",
                label: "Státusz",
                filter: {
                    type: "simple",
                },
                slot_name: "deleted_format",
                visibility: true,
            },
            {
                name: "employeeState",
                label: "Állapot",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getStaffEmployeeStates,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formRequired: true,
                formSize: 2,
                formVisible: true
            },
            {
                name: "user",
                label: "Felhasználó",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getNurseUsers,
                    formatText: function (val) {
                        return val.username;
                    },
                    formatOption: function (val) {
                        return val.username;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'username',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true
            },
            {
                name: "companyId",
                label: "Cég azonosító",
                visibility: false,
            },
            {
                name: "siteId",
                label: "Telephely azonosító",
                visibility: false,
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
            },
            {
                name: "employeeType",
                label: "Dolgozó típus",
                visibility: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
            }
        ],

        qualificationFormIsOpen: false,
        qualificationGridIsOpen: true,
        qualificationActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új szakképzés',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newQualificationRow'
            }
        ],
        qualificationFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToQualificationGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetQualificationForm'
            }
        ],
        qualificationRowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyQualificationRow'
            }, {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyQualificationRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteQualificationRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteQualificationRow'
            }
        ],
        qualificationHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "humanResourceId",
                label: "humanResourceId",
                visibility: false,
                formVisible: false
            },
            {
                name: "nameData.text",
                label: "Képzés neve",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: false
            },
            {
                name: "occupationalGroup",
                label: "Szakmacsoport",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getOccupationalGroup,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formRequired: true,
                formSize: 6,
                formVisible: true
            },
            {
                name: "name",
                label: "Szakképzettség neve",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getQualificationNames,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formRequired: true,
                formSize: 6,
                formVisible: true
            },
            {
                name: "cycleFrom",
                label: "Képzés kezdete",
                slot_name: "cycleFrom_format",
                visibility: true,
                formType: "date",
                formRequired: true,
                formSize: 2,
                formVisible: true
            },
            {
                name: "cycleTo",
                label: "Képzés vége",
                slot_name: "cycleTo_format",
                visibility: true,
                formType: "date",
                formRequired: true,
                formSize: 2,
                formVisible: true
            },
            {
                name: "placeOfCycle",
                label: "Képzés helye",
                visibility: true,
                formType: "text",
                formRequired: true,
                formSize: 4,
                formVisible: true
            },
            {
                name: "theoriticalPoint",
                label: "Elméleti pontszám",
                visibility: true,
                formType: "number",
                formRequired: true,
                formSize: 2,
                formVisible: true
            },
            {
                name: "practicalPoint",
                label: "Gyakorlati pontszám",
                visibility: true,
                formType: "number",
                formRequired: true,
                formSize: 2,
                formVisible: true
            },
            {
                name: "fullPoint",
                label: "Összesített pontszám",
                visibility: true,
                slot_name: "fullPoint_format"
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false,
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        languageFormIsOpen: false,
        languageGridIsOpen: true,
        languageActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új nyelv',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newLanguageRow'
            }
        ],
        languageFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToLanguageGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetLanguageForm'
            }
        ],
        languageRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyLanguageRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteLanguageRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteLanguageRow'
            }
        ],
        languageHeaderFields: [
            {
                name: "id",
                label: "id",
                visibility: false,
            },
            {
                name: "humanResourceId",
                label: "humanResourceId",
                visibility: false,
            },
            {
                name: "language",
                label: "Nyelv",
                sort: true,
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "inWritingId",
                label: "Írásban",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getLanguageMark,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "inWriting.text",
                label: "Írásban",
                visibility: true,
            },
            {
                name: "orallyId",
                label: "Szóban",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getLanguageMark,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "orally.text",
                label: "Szóban",
                visibility: true,
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
            }
        ],

        companyFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToHumanResourceGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetHumanResourceCompanyForm'
            }
        ],
        companyHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "humanResourceId",
                label: "humanResourceId",
                visibility: false,
                formVisible: false
            },
            {
                name: "companyName",
                label: "Cégnév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "siteAddress",
                label: "Telephely címe",
                visibility: false,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "registrationNumber",
                label: "Cégjegyzékszám",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "taxNumber",
                label: "Adószám",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "bankAccountNumber",
                label: "Bankszámlaszám",
                visibility: false,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "companyId",
                label: "companyId",
                visibility: false,
                formVisible: false
            },
            {
                name: "employeeType",
                label: "employeeType",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
                formVisible: false
            }
        ],

        feeFormIsOpen: false,
        feeGridIsOpen: true,
        feeActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új díjazás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newFeeRow'
            }
        ],
        feeFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToFeeGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetFeeForm'
            }
        ],
        feeRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyFeeRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteFeeRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteFeeRow'
            }
        ],
        feeHeaderFields: [
            {
                name: "id",
                label: "id",
                visibility: false,
            },
            {
                name: "humanResourceId",
                label: "humanResourceId",
                visibility: false,
            },
            {
                name: "treatmentId",
                label: "Kezelés",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getHRTreatment,
                    formatText: function (val) {
                        return val.title;
                    },
                    formatOption: function (val) {
                        return val.title;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'title',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formRequired: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "treatment.title",
                label: "Kezelés",
                visibility: true,
            },
            {
                name: "treatment.price",
                label: "Kezelés ára",
                visibility: true,
                slot_name: "treatment_price_format"
            },
            {
                name: "amount",
                label: "Összeg",
                visibility: true,
                formType: "number",
                slot_name: "commission_format2",
                formSize: 3,
                formVisible: true
            },
            {
                name: "percent",
                label: "Százalék",
                visibility: true,
                formType: "number",
                formSize: 3,
                formVisible: true
            },
            {
                name: "commissionAmount",
                label: "Jutalék összege",
                visibility: true,
                formVisible: false,
                slot_name: "commissionAmountFormat"
            },
            {
                name: "comment",
                label: "Megjegyzés",
                visibility: false,
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "companyId",
                label: "companyId",
                visibility: false,
            },
            {
                name: "employeeType",
                label: "employeeType",
                visibility: false,
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false,
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
            }
        ]
    }
}
